import React, { useState } from 'react';
import { Button } from '../../components/ui/button';
import { ResponseButton } from '../../components/ResponseButton';
import {
  useSelectedPatient,
  useUpdatePatient,
} from '../../hooks/patient.hooks';
import { PatientPageLayout } from '@/components/PatientPageLayout';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { enqueueSnackbar } from 'notistack';

export const UnsubscribeConfirm: React.FC = () => {
  const [emailChecked, setEmailChecked] = useState(false);
  const [smsChecked, setSmsChecked] = useState(false);
  const { mutate: updatePatient } = useUpdatePatient();
  const { data: patient } = useSelectedPatient();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const handleConfirm = () => {
    if (!patient?.id) {
      enqueueSnackbar(
        'Une erreur est survenue lors de la mise à jour des préférences de communication, veuillez nous excuser pour le désagrément.',
        {
          variant: 'error',
          autoHideDuration: 5000,
        },
      );
      return;
    }

    updatePatient(
      {
        id: patient?.id,
        unsubscribedFromEmails: emailChecked,
        unsubscribedFromSMS: smsChecked,
      },
      {
        onSuccess: () => {
          navigate('/unsub-validation');
        },
        onError: () => {
          enqueueSnackbar(
            'Une erreur est survenue lors de la mise à jour des préférences de communication, veuillez nous excuser pour le désagrément.',
            {
              variant: 'error',
              autoHideDuration: 5000,
            },
          );
        },
      },
    );
  };

  return (
    <div className="h-full flex flex-col px-4 n2xs:px-6 nsm:px-0">
      <PatientPageLayout
        title={
          <h1 className="text-2xl min-[23rem]:text-3.5xl font-semibold leading-tight nxs:text-center">
            Se désinscrire des communications
          </h1>
        }
        footer={
          <div className="flex flex-col gap-2 w-full items-center">
            <Button
              onClick={handleConfirm}
              disabled={!emailChecked && !smsChecked}
              variant="ctaPrimary"
              size="lg"
            >
              Confirmer la désinscription
            </Button>
            {searchParams.get('source') === 'menu' && (
              <Button
                onClick={() => navigate(-1)}
                variant="ctaSecondary"
                size="lg"
              >
                Annuler
              </Button>
            )}
          </div>
        }
      >
        <div className="flex flex-col justify-center items-center gap-6 nxs:text-center">
          <p className="font-light">
            Aldebaran envoie des invitations de la part de votre médecin. Vous
            pouvez choisir de ne plus en recevoir.
          </p>

          <p className="font-light">
            Choisissez les types de communications dont vous souhaitez vous
            désinscrire.
          </p>

          <div className="flex flex-col gap-2 w-full">
            <ResponseButton
              multiselect
              label="Emails"
              selected={emailChecked}
              onChange={setEmailChecked}
              justifyStart
            />

            <ResponseButton
              multiselect
              label="SMS"
              selected={smsChecked}
              onChange={setSmsChecked}
              justifyStart
            />
          </div>
        </div>
      </PatientPageLayout>
    </div>
  );
};
